<ngx-loading [show]="loading"></ngx-loading>
<div class="genre-edit">
    <div class="create-genres">
        <input placeholder="Genre name" class="form-control m-input" [(ngModel)]="genreName">
        <button (click)="addGenre()" class="btn btn-success" style="margin-left: 15px">Add New Genre</button>
    </div>

    <span *ngIf="invalidName" class="error-msg">Genre name must be at least 2 characters long</span>

    <ul class="genre-list">
        <li *ngFor="let genre of genres">
            {{ genre.name }}
            <button (click)="removeGenre(genre)"><span>+</span></button>
        </li>
    </ul>
</div>
